import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

// project imports
import { APP_DEFAULT_PATH } from 'config';
import useAuth from 'hooks/useAuth';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }) {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      // Determine the destination: prioritised redirect path, or the global default path
      const destination = location?.state?.from || APP_DEFAULT_PATH;

      // If the intended destination is the root or login page, force them to the default app path
      const finalPath = (destination === '/' || destination === '/login') ? APP_DEFAULT_PATH : destination;

      navigate(finalPath, {
        state: {
          from: '' // Clear out the state history safely
        },
        replace: true
      });
    }
    // FIX: Destructure location parameters to track primitives, breaking object reference loops
  }, [isLoggedIn, navigate, location.state?.from, location.pathname]);

  return children;
}

GuestGuard.propTypes = { children: PropTypes.any };
